module.exports = {
	"name": "HMap",
	"version": "1.1.0",
	"private": false,
	"description": "WEBGIS API",
	"keywords": [
		"webgis",
		"canvas",
		"openlayer3",
		"es6"
	],
	"author": "FDD <smileFDD@gmail.com>",
	"repository": {
		"type": "git",
		"url": "https://github.com/sakitam-fdd/HMap.git"
	},
	"main": "dist/HMap.js",
	"scripts": {
		"build": "webpack --env build",
		"dev": "webpack --progress --colors --watch --env dev",
		"test": "mocha --compilers js:babel-core/register --colors ./test/*.spec.js",
		"test:watch": "mocha --compilers js:babel-core/register --colors -w ./test/*.spec.js"
	},
	"dependencies": {
		"jquery": "^3.1.1",
		"openlayers": "^4.0.1",
		"proj4": "^2.4.3",
		"zrender": "^3.2.2"
	},
	"devDependencies": {
		"babel": "^6.0.0",
		"babel-core": "^6.0.0",
		"babel-eslint": "^7.0.0",
		"babel-loader": "^6.0.0",
		"babel-plugin-add-module-exports": "0.1.2",
		"babel-plugin-transform-runtime": "^6.0.0",
		"babel-preset-es2015": "^6.0.0",
		"babel-preset-stage-2": "^6.0.0",
		"babel-register": "^6.0.0",
		"chai": "^3.0.0",
		"chalk": "^1.1.3",
		"css-loader": "^0.28.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.5.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-standard": "^2.0.1",
		"mocha": "^2.0.0",
		"style-loader": "^0.16.1",
		"webpack": "^2.2.0",
		"webpack-dev-middleware": "^1.8.3",
		"webpack-hot-middleware": "^2.12.2",
		"webpack-merge": "^0.14.1",
		"yargs": "^6.0.0"
	},
	"license": "MIT"
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 43
// module chunks = 0